import { ref } from 'vue';
import { academicYearsService } from '@/services/academicYearsService';

// Module-level shared cache: every consumer (navbar, contents hero, home hero, …)
// reads the same list and triggers at most one network request. This is the single
// source of truth for resolving an academic_year_id → its Arabic display name.
const academicYears = ref([]);
const loaded = ref(false);
let inflight = null;

export function useAcademicYears() {
  async function fetchAcademicYears() {
    if (loaded.value) return academicYears.value;
    if (inflight) return inflight;

    inflight = academicYearsService
      .getAll()
      .then((years) => {
        academicYears.value = years;
        loaded.value = true;
        return years;
      })
      .catch(() => {
        academicYears.value = [];
        return [];
      })
      .finally(() => {
        inflight = null;
      });

    return inflight;
  }

  // Returns the Arabic name (e.g. "أولى إعدادي"). Returns '' when the list has not
  // loaded yet or the id can't be resolved, so callers can render nothing.
  function getAcademicYearName(id) {
    if (id === null || id === undefined || id === '') return '';
    const year = academicYears.value.find((y) => y.id === Number(id));
    return year?.name || '';
  }

  return {
    academicYears,
    loaded,
    fetchAcademicYears,
    getAcademicYearName,
  };
}
